import { EntityModel } from '@/interfaces'
import {
  ALL_ESIM_CONFIGS_QUERY,
  CREATE_ESIM_CONFIG_MUTATION,
  DELETE_ESIM_CONFIG_MUTATION,
  FORCE_DELETE_ESIM_CONFIG_MUTATION,
  SINGLE_ESIM_CONFIG_QUERY,
  UPDATE_ESIM_CONFIG_MUTATION,
} from './graphql'
import ratioEsimRegionEntity from '@/entities/ratioEsimRegion/entity'

const ratioEsimConfigModel: EntityModel = {
  name: 'esimConfig',
  namePlural: 'esimConfigs',
  uniqueName: 'ratioEsimConfig',
  uniqueNamePlural: 'ratioEsimConfigs',
  path: 'config/ratio/esim/esim_config',
  baseUrl: '/config/ratio/esim/esim_configs',
  translationPrefix: 'entities:ratioEsimConfig.',
  getDisplayName: (values: any) => {
    return 'ESIM CONFIG'
  },
  gql: {
    getAll: ALL_ESIM_CONFIGS_QUERY,
    getSingle: SINGLE_ESIM_CONFIG_QUERY,
    create: CREATE_ESIM_CONFIG_MUTATION,
    update: UPDATE_ESIM_CONFIG_MUTATION,
    delete: DELETE_ESIM_CONFIG_MUTATION,
    forceDelete: FORCE_DELETE_ESIM_CONFIG_MUTATION,
  },
  attributes: {
    enabled: {
      name: 'enabled',
      label: 'entities:ratioEsimConfig.attributes.enabled.label',
      type: 'value',
      dataType: 'boolean',
      defaultInput: true,
      inputType: 'switch',
      validationType: 'string',
      validations: [],
    },
    regions: {
      name: 'regions',
      label: 'entities:ratioEsimConfig.attributes.regions.label',
      type: 'entityCollection',
      dataType: '[any]',
      getEntity: () => {
        return ratioEsimRegionEntity
      },
      defaultInput: false,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
  },
}

export default ratioEsimConfigModel
